module.exports = __webpack_public_path__ + "media/metronic/_theme/media/bg/bg-5-291231257db974eb2e53a17657d510ad.jpg";